import React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import proworklogo from "./logo1.jpeg";
const HeaderDiv = styled.div`
    @media print {
        visibility: visible;
    }
    @media only screen {
        visibility: collapse;
        margin: 0px;
        height: 0px;
    }
    margin: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
const Header = ({ date = null, reportType }) => {
    return (
        <HeaderDiv>
            <div>
                <Typography variant="title">{reportType}</Typography>
                <Typography variant="subheading">
                    {date && date.replace(/_/g, " ").replace(/\./g, ":")}
                </Typography>
            </div>
            <div style={{ display: "flex" }}>
                <img
                    src={proworklogo}
                    alt="logo"
                    style={{ height: 50, borderRadius: 10, marginRight: 30 }}
                />

                <div style={{ marginRight: 30 }}>
                    <Typography variant="subheading">ProWork</Typography>
                    <Typography variant="caption">
                        Email: wolf@prowork.ie
                    </Typography>
                    <Typography variant="caption">Tel: 087 957 1868</Typography>
                </div>
            </div>
        </HeaderDiv>
    );
};
export default Header;
